import { render, staticRenderFns } from "./RegisterTechnicalSupport.vue?vue&type=template&id=88ce4236"
import script from "./RegisterTechnicalSupport.vue?vue&type=script&lang=js"
export * from "./RegisterTechnicalSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports